// src/cert/soc.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const SOC = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>SOC प्रमाणन</h1>
                <p>सेवा संस्था नियंत्रणे (Service Organization Control)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>SOC म्हणजे काय?</h2>
                    <p>
                        Security operations center as a service (SOCaaS) is a cloud-based subscription model for managed threat detection and response that includes best-in-class SOC solutions and capabilities to help fill in gaps on existing security teams.

                        Benefits of SOC as a Service (SOCaaS)?

                        Outsourcing security operations and information security management provides a handful of benefits, including the following

                        Cost reductions

                        Faster detection and more efficient remediation to help streamline security events

                        Access to best-of-breed security solutions

                        Reducing the burden on internal SecOps teams

                        Continuous monitoring

                        Speeding up detection/response to deliver high-confidence alerts and reduce alert fatigue

                        Minimizing turnover and reducing security analyst burnout; removing mundane tasks

                        Reduced complexity

                        Lower cyber risk

                        Enhanced business scalability and agility

                        Conversely, issues from legacy SOC environments can include

                        Lack of visibility and context

                        Increased complexity of investigations

                        Lack of interoperability of systems

                        Lack of automation and orchestration

                        Inability to collect, process and contextualize threat intelligence data

                        Alert fatigue/noise from the high-volume, low-fidelity alerts of security controls

                    </p>
                    <p><strong>प्रकार:</strong> SOC 1, SOC 2, SOC 3</p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>ग्राहकांना तुमची सुरक्षा आणि विश्वासार्हता सिद्ध होते</li>
                        <li>SOC 2: सुरक्षा, उपलब्धता, गोपनीयता, प्रक्रिया अखंडता</li>
                        <li>क्लाउड, SaaS, BPO, पेमेंट कंपन्यांसाठी आवश्यक</li>
                        <li>अमेरिका, युरोपमधील ग्राहकांचा विश्वास वाढतो</li>
                        <li>कायदेशीर आणि करार अनुपालन (SOX, HIPAA)</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>SOC साठी अर्ज करा</h2>
                    <ApplyForm certification="SOC" />
                </section>
            </div>
        </div>
    );
};

export default SOC;